



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const OPTIONS = [
  {
    value: '1',
    label: '实物',
  },
  {
    value: '2',
    label: '虚拟',
    children: [
      {
        value: '0',
        label: '无',
      },
      {
        value: '1',
        label: '兑换码',
      },
    ],
  },
];
@Component
export default class EditFirst extends Vue {
  is_loading: boolean = false;
  options: any = OPTIONS;
  text: any = '物流发货';
  is_need_address: boolean = true; // 是否需要填写地址
  need_express: number = 1;
  ware_type: any = ['1'];
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  form_data: object = {};

  onChange(value: any) {
    if (value.length === 1) {
      this.text = '物流发货';
      this.is_need_address = true;
      this.need_express = 1;
    } else {
      this.text = value[1] === '0' ? '无需发货' : '发兑换码';
      this.is_need_address = false;
      this.need_express = 2;
    }
  }

  nextStep() {
    this.form_data = {
      type: this.ware_type,
      need_express: this.need_express,
    };
    storage.setItem('ware_first', JSON.stringify(this.form_data));
    this.$router.push('/ware/edit-second/0');
  }
}
